export class Colors {
	// Use lowercase letters for hex codes or focus will not work
	static ChartDefaults: Array<string> = [
		"#607d8b",	// GREY BLUE
		"#9e9e9e",	// GREY
		"#795548",	// BROWN
		"#ff5722",	// RED ORANGE
		"#ff9800",	// ORANGE
		"#ffc107",	// GOLD
		"#8bc34a",	// PUKE GREEN
		"#4caf50",	// GREEN
		"#009688",	// GREEN TEAL
		"#00bcd4",	// TEAL
		"#03a9f4",	// LIGHT BLUE
		"#2196f3",	// BLUE
		"#3f51b5",	// BLUE PURPLE
		"#673ab7",	// PURPLE
		"#9c27b0",	// VIOLET
		"#e91e63",	// PINK
		"#f44336",	// RED
		"#000000"	// BLACK
	];
}
